import { Footer, SiteAdminHeader } from '@/components/organisms';
import { SiteAdminServerErrorTemplate } from '@/components/templates';
import SiteAdminNotFoundTemplate from '@/components/templates/SiteAdminNotFoundTemplate';
import { ConsoleTemplate } from '@/components/templates/ConsoleTemplate';
import { SiteAdminDashboard } from '@/pages/admin/site-admin-dashboard/SiteAdminDashboard';
import SiteAdminClinicsListPage from '@/pages/admin/admin-clinics/SiteAdminClinicsListPage';
import CreateClinicPage from '@/pages/admin/admin-clinics/CreateClinicPage';
import EditClinicPage from '@/pages/admin/admin-clinics/EditClinicPage';
import SiteAdminClinicDetailPage from '@/pages/admin/site-admin-clinic-detail/SiteAdminClinicDetailPage';
import SiteAdminClinicLocationsListPage from '@/pages/admin/admin-clinic-locations/SiteAdminClinicLocationsListPage';
import CreateClinicLocationPage from '@/pages/admin/admin-clinic-locations/CreateClinicLocationPage';
import EditClinicLocationPage from '@/pages/admin/admin-clinic-locations/EditClinicLocationPage';
import ClinicLocationDetailPage from '@/pages/admin/admin-clinic-locations/ClinicLocationDetailPage';
import CreateClinicLocationManagerPage from '@/pages/admin/admin-clinic-locations/CreateClinicLocationManagerPage';
import EditClinicLocationManagerPage from '@/pages/admin/admin-clinic-locations/EditClinicLocationManagerPage';
import EditClinicLocationMassagerPage from '@/pages/admin/admin-clinic-locations/EditClinicLocationMassagerPage';
import SiteAdminClinicInformationsListPage from '@/pages/admin/site-admin-clinic-info/SiteAdminClinicInformationsListPage';
import SiteAdminClinicInfoCreatePage from '@/pages/admin/site-admin-clinic-info/SiteAdminClinicInfoCreatePage';
import SiteAdminClinicInfoEditPage from '@/pages/admin/site-admin-clinic-info/SiteAdminClinicInfoEditPage';
import SiteAdminClinicInfoCopyPage from '@/pages/admin/site-admin-clinic-info/SiteAdminClinicInfoCopyPage';
import ClinicUserListPage from '@/pages/admin/admin-clinic-users/ClinicUserListPage';
import CreateClinicUserPage from '@/pages/admin/admin-clinic-users/CreateClinicUserPage';
import EditClinicUserPage from '@/pages/admin/admin-clinic-users/EditClinicUserPage';
import SiteAdminMassagersListPage from '@/pages/admin/admin-massagers/SiteAdminMassagersListPage';
import CreateMassagerPage from '@/pages/admin/admin-massagers/CreateMassagerPage';
import EditMassagerPage from '@/pages/admin/admin-massagers/EditMassagerPage';
import SiteAdminDistanceCachesListPage from '@/pages/admin/admin-distance-caches/SiteAdminDistanceCachesListPage';
import SiteAdminDistanceCachesDetailPage from '@/pages/admin/admin-distance-caches/SiteAdminDistanceCachesDetailPage';
import SiteAdminDistanceCachesEditPage from '@/pages/admin/admin-distance-caches/SiteAdminDistanceCachesEditPage';
import SiteAdminLatlonCachesListPage from '@/pages/admin/admin-latlon-caches/SiteAdminLatlonCachesListPage';
import SiteAdminLatlonCachesCreatePage from '@/pages/admin/admin-latlon-caches/SiteAdminLatlonCachesCreatePage';
import SiteAdminLatlonCachesDetailPage from '@/pages/admin/admin-latlon-caches/SiteAdminLatlonCachesDetailPage';
import SiteAdminLatlonCachesEditPage from '@/pages/admin/admin-latlon-caches/SiteAdminLatlonCachesEditPage';
import SiteAdminInsurerPage from '@/pages/admin/site-admin-insurer/SiteAdminInsurerPage';
import SiteAdminCreateInsurerPage from '@/pages/admin/site-admin-insurer/SiteAdminCreateInsurerPage';
import SiteAdminEditInsurerPage from '@/pages/admin/site-admin-insurer/SiteAdminEditInsurerPage';
import SiteAdminInsurerDetailPage from '@/pages/admin/site-admin-insurer/SiteAdminInsurerDetailPage';
import RezeptHistoriesPage from '@/pages/admin/admin-rezept-histories/RezeptHistoriesPage';
import SiteAdminCopyInsurerPage from '@/pages/admin/site-admin-insurer/SiteAdminCopyInsurerPage';
import SiteAdminInformationListPage from '@/pages/admin/site-admin-informations/SiteAdminInformationListPage';
import SiteAdminInformationCreatePage from '@/pages/admin/site-admin-informations/SiteAdminInformationCreatePage';
import SiteAdminInformationDetailPage from '@/pages/admin/site-admin-informations/SiteAdminInformationDetailPage';
import SiteAdminInformationEditPage from '@/pages/admin/site-admin-informations/SiteAdminInformationEditPage';
import SiteAdminInsurerAttentionPage from '@/pages/admin/site-admin-insurer-attention/SiteAdminInsurerAttentionPage';
import SiteAdminInsurerAttentionCreatePage from '@/pages/admin/site-admin-insurer-attention/SiteAdminInsurerAttentionCreatePage';
import SiteAdminInsurerAttentionEditPage from '@/pages/admin/site-admin-insurer-attention/SiteAdminInsurerAttentionEditPage';
import SiteAdminSpecialCalculationCostListPage from '@/pages/admin/site-admin-special-calculation-costs/SiteAdminSpecialCalculationCostListPage';
import SiteAdminSpecialCalculationCostDetailPage from '@/pages/admin/site-admin-special-calculation-costs/SiteAdminSpecialCalculationCostDetailPage';
import SiteAdminRezeptLimitsPage from '@/pages/admin/site-admin-rezept-limits/SiteAdminRezeptLimitsPage';
import SiteAdminRezeptSheetsPage from '@/pages/admin/site-admin-rezept-sheets/SiteAdminRezeptSheetsPage';
import SiteAdminDeleteClinicsPage from '@/pages/admin/site-admin-delete-clinics/SiteAdminDeleteClinicsPage';
import HolidayListPage from '@/pages/admin/admin-holidays/HolidayListPage';
import AdminUserListPage from '@/pages/admin/admin-admins/AdminUserListPage';
import OrderRezeptSheetsPage from '@/pages/admin/admin-order-rezept-sheets/OrderRezeptSheetsPage';
import OrderRezeptSheetEditPage from '@/pages/admin/admin-order-rezept-sheets/OrderRezeptSheetEditPage';
import SiteAdminTownPage from '@/pages/admin/admin-towns/SiteAdminTownPage';
import SiteAdminTownEditPage from '@/pages/admin/admin-towns/SiteAdminTownEditPage';
import { ClinicDesignTemplatePage } from '@/pages/design-template';
import { NotFound } from '@/pages/main/system/NotFound';
import AdminSidebar from '@/shared/layouts/AdminSidebar';
import React, { useState } from 'react';
import { Outlet, RouteObject } from 'react-router-dom';

/**
 * Site Admin Router Layout Component
 * Wraps all site admin routes with the console template, sidebar, header, and footer
 */
export const SiteAdminRouterLayout: React.FC = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  return (
    <ConsoleTemplate
      sidebarOpen={sidebarOpen}
      header={<SiteAdminHeader onMenuClick={() => setSidebarOpen(!sidebarOpen)} />}
      sidebar={<AdminSidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />}
      footer={<Footer useAdmin={true} />}
    >
      <Outlet />
    </ConsoleTemplate>
  );
};

/**
 * Site Admin Route Configuration
 * Defines all routes available within the site admin portal
 */
export const siteAdminRoutes: RouteObject[] = [
  { index: true, element: <SiteAdminDashboard /> },
  { path: 'home', element: <SiteAdminDashboard /> },

  {
    path: 'clinics',
    children: [
      { index: true, element: <SiteAdminClinicsListPage /> },
      { path: 'create', element: <CreateClinicPage /> },
      { path: ':id', element: <SiteAdminClinicDetailPage /> },
      { path: ':id/edit', element: <EditClinicPage /> },
    ],
  },

  {
    path: 'clinic_informations',
    children: [
      { index: true, element: <SiteAdminClinicInformationsListPage /> },
      { path: 'create', element: <SiteAdminClinicInfoCreatePage /> },
      { path: ':id/edit', element: <SiteAdminClinicInfoEditPage /> },
      { path: ':id/copy', element: <SiteAdminClinicInfoCopyPage /> },
    ],
  },

  {
    path: 'clinic_locations',
    children: [
      { index: true, element: <SiteAdminClinicLocationsListPage /> },
      { path: 'create', element: <CreateClinicLocationPage /> },
      { path: ':id/clinic_location_managers/create', element: <CreateClinicLocationManagerPage /> },
      {
        path: ':id/clinic_location_managers/:managerId/edit',
        element: <EditClinicLocationManagerPage />,
      },
      {
        path: ':id/clinic_location_massagers/:massagerId/edit',
        element: <EditClinicLocationMassagerPage />,
      },
      { path: ':id/edit', element: <EditClinicLocationPage /> },
      { path: ':id', element: <ClinicLocationDetailPage /> },
    ],
  },

  {
    path: 'clinic_users',
    children: [
      { index: true, element: <ClinicUserListPage /> },
      { path: 'create', element: <CreateClinicUserPage /> },
      { path: ':id/edit', element: <EditClinicUserPage /> },
    ],
  },

  {
    path: 'massagers',
    children: [
      { index: true, element: <SiteAdminMassagersListPage /> },
      { path: 'create', element: <CreateMassagerPage /> },
      { path: ':id/edit', element: <EditMassagerPage /> },
    ],
  },

  {
    path: 'distance_caches',
    children: [
      { index: true, element: <SiteAdminDistanceCachesListPage /> },
      { path: ':id', element: <SiteAdminDistanceCachesDetailPage /> },
      { path: ':id/edit', element: <SiteAdminDistanceCachesEditPage /> },
    ],
  },

  {
    path: 'latlon_caches',
    children: [
      { index: true, element: <SiteAdminLatlonCachesListPage /> },
      { path: 'create', element: <SiteAdminLatlonCachesCreatePage /> },
      { path: ':id', element: <SiteAdminLatlonCachesDetailPage /> },
      { path: ':id/edit', element: <SiteAdminLatlonCachesEditPage /> },
    ],
  },

  {
    path: 'insurers',
    children: [
      { index: true, element: <SiteAdminInsurerPage /> },
      { path: 'create', element: <SiteAdminCreateInsurerPage /> },
      { path: ':id/edit', element: <SiteAdminEditInsurerPage /> },
      { path: ':id', element: <SiteAdminInsurerDetailPage /> },
      { path: ':id/copy', element: <SiteAdminCopyInsurerPage /> },
    ],
  },

  {
    path: 'insurer_attentions',
    children: [
      { index: true, element: <SiteAdminInsurerAttentionPage /> },
      { path: 'create', element: <SiteAdminInsurerAttentionCreatePage /> },
      { path: ':id/edit', element: <SiteAdminInsurerAttentionEditPage /> },
    ],
  },

  {
    path: 'special_calculation_costs',
    children: [
      { index: true, element: <SiteAdminSpecialCalculationCostListPage /> },
      { path: ':id', element: <SiteAdminSpecialCalculationCostDetailPage /> },
    ],
  },

  { path: 'rezept_histories', element: <RezeptHistoriesPage /> },
  {
    path: 'informations',
    children: [
      { index: true, element: <SiteAdminInformationListPage /> },
      { path: 'create', element: <SiteAdminInformationCreatePage /> },
      { path: ':id', element: <SiteAdminInformationDetailPage /> },
      { path: 'edit/:id', element: <SiteAdminInformationEditPage /> },
    ],
  },

  { path: 'rezept_limits', element: <SiteAdminRezeptLimitsPage /> },
  { path: 'rezept_sheets', element: <SiteAdminRezeptSheetsPage /> },
  { path: 'delete_clinics', element: <SiteAdminDeleteClinicsPage /> },
  { path: 'holidays', element: <HolidayListPage /> },

  { path: 'admins', element: <AdminUserListPage /> },

  { path: 'order_rezept_sheets', element: <OrderRezeptSheetsPage /> },
  { path: 'order_rezept_sheets/:id/edit', element: <OrderRezeptSheetEditPage /> },
  {
    path: 'towns',
    children: [
      { index: true, element: <SiteAdminTownPage /> },
      { path: ':id/edit', element: <SiteAdminTownEditPage /> },
    ],
  },
  { path: 'design-template', element: <ClinicDesignTemplatePage /> },
  { path: 'server-error', element: <SiteAdminServerErrorTemplate /> },
  /** Explicit 404 (same layout as detail API 404); use navigate(`/:site/admin/404`). */
  { path: '404', element: <SiteAdminNotFoundTemplate /> },
  { path: '*', element: <NotFound /> },
];
